import { render } from "./route-options.vue?vue&type=template&id=5adfbebf&scoped=true&ts=true"
import script from "./route-options.vue?vue&type=script&lang=ts"
export * from "./route-options.vue?vue&type=script&lang=ts"

import "./route-options.vue?vue&type=style&index=0&id=5adfbebf&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5adfbebf"]])

export default __exports__